"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../ThemeProvider");

var _Balloon = _interopRequireDefault(require("../Balloon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var hasScore = function hasScore(props) {
  return _react["default"].createElement("div", {
    className: props.theme.container
  }, _react["default"].createElement("div", {
    className: props.theme.scoreBar
  }), _react["default"].createElement("div", {
    style: {
      marginLeft: "".concat((props.score - 350) / 500 * 100, "%")
    }
  }, _react["default"].createElement(_Balloon["default"], {
    score: props.score,
    color: props.color,
    shouldDisplace: true
  })));
};

var noScore = function noScore(props) {
  return _react["default"].createElement(_Balloon["default"], {
    score: props.score
  });
};

var ScoreBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ScoreBar, _Component);

  function ScoreBar() {
    _classCallCheck(this, ScoreBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScoreBar).apply(this, arguments));
  }

  _createClass(ScoreBar, [{
    key: "render",
    value: function render() {
      var score = this.props.score;
      if (this.props.score <= 350) score = 350;else if (this.props.score >= 850) score = 850;
      return _react["default"].createElement("div", null, this.props.score ? hasScore(_objectSpread({}, this.props, {
        score: score
      })) : noScore(this.props));
    }
  }]);

  return ScoreBar;
}(_react.Component);

hasScore.propTypes = {
  score: _propTypes["default"].number,
  theme: _propTypes["default"].shape({
    container: _propTypes["default"].string,
    scoreBar: _propTypes["default"].string
  }).isRequired,
  color: _propTypes["default"].string.isRequired
};
noScore.propTypes = {
  score: _propTypes["default"].number
};
ScoreBar.propTypes = {
  score: _propTypes["default"].number
};

var _default = (0, _ThemeProvider.applyTheme)('ScoreBar', ScoreBar);

exports["default"] = _default;